import React from "react";
import { cn } from "../../lib/utils";

// Main Card container

export function Card({ children, style }) {
  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: "20px",
        boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
        padding: 24,
        width: "100%",
        maxWidth: 420,
        position: "relative",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children }) {
  return (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      {children}
    </div>
  );
}

export function CardTitle({ children }) {
  return (
    <h2 style={{ fontSize: 26, fontWeight: "bold", margin: 0 }}>
      {children}
    </h2>
  );
}

export function CardDescription({ children }) {
  return (
    <p style={{ color: "#666", fontSize: 14, marginTop: 6 }}>
      {children}
    </p>
  );
}

export function CardContent({ children }) {
  return (
    <div style={{ marginTop: 20 }}>
      {children}
    </div>
  );
}

//export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
